import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { Dimensions } from 'react-native';
import { useTheme } from './theme';
var {
  width
} = Dimensions.get('window');

var getResponsiveValue = function getResponsiveValue(value) {
  var theme = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var {
    breakpoints: [_minMobile = 0, minTablet = 576, minDesktop = 992] = [],
    screenWidth = width
  } = theme;

  if (Array.isArray(value)) {
    if (screenWidth >= minDesktop) {
      return value[2] || value.pop();
    } else if (screenWidth >= minTablet) {
      return value[1] || value.pop();
    } else {
      return value[0];
    }
  }

  return value;
};

export var useResponsiveValue = value => {
  return getResponsiveValue(value, useTheme());
};
export default getResponsiveValue;